import { FC, useEffect } from 'react';
import './index.css';
import { useDispatch, useSelector } from 'react-redux';
import { getCacheRefreshRequest } from 'redux/reducers/dashboard/reducer';
import { getOrganization } from 'redux/reducers/user/selectors';
import { Box } from '@mui/material';
import { Euro } from '@mui/icons-material';
import { SalesInformation } from './SalesInformation';
import { Chart } from './Chart';
import { TotalTaxes } from './TotalTaxes';
import { EuropeMap } from './EuropeMap';

export const Dashboard: FC = () => {
	const dispatch = useDispatch();
	const organization = useSelector(getOrganization);

	useEffect(() => {
		const emId = organization?.id;
		if (!emId) return;
		dispatch(getCacheRefreshRequest());
	}, [dispatch, organization]);
	return (
		<div style={{ padding: '0px 10px 0 10px' }}>
			<TotalTaxes />
			<SalesInformation />
			<Chart />
			{/* <EuropeMap /> */}
		</div>
	);
};
